import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import useCanViewPersonalizations from 'personalization-lib/hooks/auth/useCanViewPersonalizations';
import { useGetPersonalizationStrategyQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeRpc.hooks';
const usePersonalizationStrategy = (strategyId, options) => {
  const hasPersonalizationAccess = useCanViewPersonalizations();
  const _useGetPersonalizatio = useGetPersonalizationStrategyQuery(Object.assign({
      variables: {
        id: strategyId
      },
      skip: !strategyId || !hasPersonalizationAccess
    }, options)),
    {
      data
    } = _useGetPersonalizatio,
    rest = _objectWithoutPropertiesLoose(_useGetPersonalizatio, _excluded);
  return Object.assign({
    strategy: data === null || data === void 0 ? void 0 : data.personalizationStrategy
  }, rest);
};
export default usePersonalizationStrategy;